import React, { useEffect, useMemo, useState } from 'react';
import './css/WeatherPreview.css';
import './css/WeatherPreviewResponsive.css';
import { WEATHER_TRANSLATIONS } from '../../../../../Constants/apps';
import { useSelector } from 'react-redux';
import { getDisplayName } from '../../Helpers';

const WeatherPreviewPortrait = ({ data, xs = false, previewMode = false, settings = null }) => {
  const [currentTime, setCurrentTime] = useState(new Date());
  const isDay = data?.current.is_day == 1 ? 1 : 0;
  const isCelsius = previewMode ? settings.unit === "c" : data?.media?.weather?.settings?.unit?.toLowerCase() === "c";
  const languageRtl = previewMode ? settings.lang_direction === "rtl" : data?.media?.weather?.settings?.lang_direction === "rtl";
  const display_name = useMemo(() => getDisplayName({ previewMode, settings, data }), [previewMode, settings, data]);

  // const display_name = previewMode ? settings.lang != "en" ? settings.location_display ? settings.location_display : "Enter City Name" : data?.location?.name : data?.media?.weather?.settings?.location_display;
  const lang = previewMode ? settings.lang ? settings.lang : "en" : data?.media?.weather?.settings?.lang;
  const weatherBgColor = useSelector((state) => state.apps.weatherBgColor);

  const langTranslate = WEATHER_TRANSLATIONS[lang];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const today = new Date();
  const nextDay = new Date(today);
  nextDay.setDate(today.getDate() + 1);
  const next2Day = new Date(today);
  next2Day.setDate(today.getDate() + 2);

  const currentDay = today.toLocaleDateString(lang, { weekday: "long" });
  const nextDayDayForecast = nextDay.toLocaleDateString(lang, { weekday: "long" });
  const next2DayDayForecast = next2Day.toLocaleDateString(lang, { weekday: "long" });

  const weekDays = [currentDay, nextDayDayForecast, next2DayDayForecast];



  const time = currentTime.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  const getWeatherIcon = (isDay, code) => {
    try {
      return require(`../../../../../assets/img/weather-icons/${isDay}/${code || 1000}.png`);
    } catch {
      return require(`../../../../../assets/img/weather-icons/1/1000.png`);
    }
  };

  const forecastDays = data?.forecast?.forecastday || [];
  const todayHours = forecastDays[0]?.hour || [];

  const containerClass = previewMode ? 'full-height-weather-preview-mode' : `full-height-weather `;
  const paneLeftClass = previewMode ? 'left-pane-preview-mode' : 'left-pane';
  const topLeftClass = previewMode ? 'top-left-preview-mode' : 'top-left';
  const cityTitleClass = previewMode ? 'weather-city-title-preview-mode' : 'weather-city-title';
  const dateRowClass = previewMode ? 'date-row-preview-mode' : 'date-row';
  const dateTagClass = previewMode ? 'date-tag-preview-mode' : 'date-tag';
  const weatherIconClass = previewMode ? 'weather-icon-current-preview-mode' : 'weather-icon-current';
  const weatherDescRightClass = previewMode ? 'weather-description-right-preview-mode' : 'weather-description-right';
  const justifyEndClass = previewMode ? 'justify-content-end-preview-mode' : 'justify-content-end';
  const currentTempValueClass = previewMode ? 'temp-weather-current-value-preview-mode' : 'temp-weather-current-value';
  const currentTempUnitClass = previewMode ? 'temp-weather-current-unit-preview-mode' : 'temp-weather-current-unit';
  const forecastRowClass = previewMode ? 'forecast-row-preview-mode' : 'forecast-row';
  const forecastCardClass = previewMode ? 'weather-forecast-card-preview-mode' : 'weather-forecast-card';
  const forecastIconClass = previewMode ? 'weather-forecast-icons-preview-mode' : 'weather-forecast-icons';
  const bottomRightClass = previewMode ? 'bottom-right-preview-mode' : 'bottom-right';
  const weatherDescClass = previewMode ? 'weather-description-preview-mode' : 'weather-description';
  const hourTextClass = previewMode ? xs ? 'text-[0.8rem]' : 'text-[1.0rem]' : 'text-[1.5vw]';
  const hourIconStyle = previewMode ? xs ? { width: '35px' } : { width: '50px' } : { width: '5vh' };

  return (
    <div className={`${containerClass} justify-content-center ${languageRtl ? 'flex-row-reverse' : ''}`}
      style={{
        backgroundColor: weatherBgColor,
        background: weatherBgColor,

      }}
    >

      <div className={paneLeftClass} style={{ width: '100%' }}>
        <div className={topLeftClass}>
          <div className={`d-flex justify-between ${languageRtl ? 'flex-row-reverse' : ''}`}>
            <div className={`${cityTitleClass} ${languageRtl ? 'text-end' : ''}`} style={previewMode ? {} : { fontSize: "5.4vh" }}>{display_name}</div>
            <div className={`d-flex align-items-center ${justifyEndClass}`}>
              <div className={currentTempValueClass} style={{ fontSize: '3.3rem' }}>{isCelsius ? Math.round(data?.current?.temp_c) : Math.round(data?.current?.temp_f)}</div>
              <div className={currentTempUnitClass}>°{isCelsius ? 'C' : 'F'}</div>
            </div>
          </div>
          <div
            style={previewMode ? xs ? { fontSize: '0.75rem' } : {} : { fontSize: "2.0vh" }}
            className={`d-flex align-items-center justify-between ${dateRowClass} ${languageRtl ? ' flex-row-reverse' : ''}`}>
            <div className={dateTagClass} >{langTranslate["today"]}</div>
            <div style={previewMode ? xs ? { fontSize: '0.75rem' } : {} : { fontSize: "2.0vh" }} className="d-flex align-items-center date-weather-live flex-column">
              <div>{currentDay}</div>
              <div>{time}</div>
            </div>
          </div>
        </div>
        <div className={weatherIconClass}>
          <img src={getWeatherIcon(isDay, data?.current?.condition?.code)} className="img-fluid" style={previewMode ? xs ? { width: '180px' } : { width: '240px' } : { width: '35vh' }} alt="icon" />
        </div>
        <div className={weatherDescRightClass} style={previewMode ? {} : { fontSize: "3.4vh" }}>{data?.current?.condition?.text}</div>

        <div className={`${forecastRowClass} ${languageRtl ? 'flex-row-reverse' : ''}`} style={previewMode ? {} : { margin: "2vh 0" }}>
          {forecastDays.slice(0, 3).map((forecast, idx) => (
            <div key={idx} className={forecastCardClass} style={xs ? { padding: '10px' } : {}}>
              <div className='w-[65%]'>
                <div>{weekDays[idx]}</div>
                <div className="d-flex align-items-center" style={xs ? { fontSize: '0.5rem' } : {}}>
                  <span>{isCelsius ? Math.round(forecast?.day?.maxtemp_c) : Math.round(forecast?.day?.maxtemp_f)}°</span>
                  <span className="slash mx-1">/</span>
                  <span>{isCelsius ? Math.round(forecast?.day?.mintemp_c) : Math.round(forecast?.day?.mintemp_f)}°</span>
                </div>
              </div>
              <div className='w-[35%]'>
                <img src={getWeatherIcon(1, forecast?.day?.condition?.code)} className={`${forecastIconClass} img-fluid`} style={{ width: '100%' }} alt="forecast" />
              </div>

            </div>
          ))}
        </div>

        {previewMode ? "" :
          <div className={bottomRightClass}>
            <div className={`${weatherDescClass} ${languageRtl ? 'text-end' : ''}`} style={xs ? { fontSize: '0.9rem' } : previewMode ? {} : { fontSize: "2.4vh" }}>{data?.current?.condition?.text}</div>
            <div className={`w-full h-full gap-4 flex items-center justify-center p-4 ${languageRtl ? 'flex-row-reverse' : ''}`}>
              {[8, 12, 15, 18, 20, 23].map((hr, idx) => (
                <div key={idx} className="w-100 text-center d-flex flex-column justify-center gap-3 items-center">
                  <div className={hourTextClass} style={previewMode ? {} : { fontSize: "1.4vh" }}>{`${hr}:00`}</div>
                  <img
                    src={getWeatherIcon(hr > 18 ? 0 : 1, todayHours[hr]?.condition?.code)}
                    className={`${forecastIconClass} img-fluid TEXT-CENTER`}
                    style={hourIconStyle}
                    alt="hour"
                  />
                  <div className={hourTextClass} style={previewMode ? {} : { fontSize: "1.4vh" }}>{isCelsius ? Math.round(todayHours[hr]?.temp_c) : Math.round(todayHours[hr]?.temp_f)}°</div>
                </div>
              ))}
            </div>
          </div>

        }
      </div>
    </div >
  );
};

export default WeatherPreviewPortrait;
